import { render, staticRenderFns } from "./option-selector.vue?vue&type=template&id=d583f1b8&scoped=true"
import script from "./option-selector.vue?vue&type=script&lang=js"
export * from "./option-selector.vue?vue&type=script&lang=js"
import style0 from "./option-selector.vue?vue&type=style&index=0&id=d583f1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d583f1b8",
  null
  
)

export default component.exports